export default __webpack_public_path__ + "static/media/gallery-img3.939fa728.jpeg";